// Copyright (c) 2025 Deere & Company

import './amount-of-use-request-status-panel.scss';
import {FormattedMessage} from 'react-intl';
import React from 'react';

const AmountOfUseRequestStatusPanel = () => (
    <section className='amount-of-use-request-status-panel'>
        <header>
            <FormattedMessage id='AMOUNT_OF_USE_REQUESTS_STATUS'/>
        </header>
    </section>
        );

export default AmountOfUseRequestStatusPanel;



// WEBPACK FOOTER //
// ./src/product/details/components/amount-of-use-history-panel/amount-of-use-request-status-panel.js